import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getEvaluations = store => store[NAME].evaluations;
export const getShowRecognitionPoints = store => store[NAME].showRecognitionPoints;
export const getShowSalaryInfo = store => store[NAME].showSalaryInfo;
export const getQuadrantData = store => store[NAME].quadrantData;
export const getSummaryData = store => store[NAME].summaryData;
export const getNpsName = store => store[NAME].npsName;